var map = {
  "./accountDetails.tsx": "./app/data/forms/accountDetails.tsx",
  "./accountEmails.tsx": "./app/data/forms/accountEmails.tsx",
  "./accountNotificationSettings.tsx": "./app/data/forms/accountNotificationSettings.tsx",
  "./accountPassword.tsx": "./app/data/forms/accountPassword.tsx",
  "./accountPreferences.tsx": "./app/data/forms/accountPreferences.tsx",
  "./apiApplication.tsx": "./app/data/forms/apiApplication.tsx",
  "./cspReports.tsx": "./app/data/forms/cspReports.tsx",
  "./inboundFilters.tsx": "./app/data/forms/inboundFilters.tsx",
  "./organizationGeneralSettings.tsx": "./app/data/forms/organizationGeneralSettings.tsx",
  "./organizationMembershipSettings.tsx": "./app/data/forms/organizationMembershipSettings.tsx",
  "./organizationSecurityAndPrivacyGroups.tsx": "./app/data/forms/organizationSecurityAndPrivacyGroups.tsx",
  "./projectAlerts.tsx": "./app/data/forms/projectAlerts.tsx",
  "./projectGeneralSettings.tsx": "./app/data/forms/projectGeneralSettings.tsx",
  "./projectIssueGrouping.tsx": "./app/data/forms/projectIssueGrouping.tsx",
  "./projectSecurityAndPrivacyGroups.tsx": "./app/data/forms/projectSecurityAndPrivacyGroups.tsx",
  "./sentryApplication.tsx": "./app/data/forms/sentryApplication.tsx",
  "./teamSettingsFields.tsx": "./app/data/forms/teamSettingsFields.tsx",
  "./userFeedback.tsx": "./app/data/forms/userFeedback.tsx"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/data/forms sync recursive \\.tsx?$";
